<template>
  <div v-for="index in 6">
    <el-button v-if="typeof(forms['city' + index]) != 'undefined' && typeof(forms['category' + index]) != 'undefined' && forms['city' + index] != null && forms['city' + index].length > 0" text @click="getTaskByLocation(forms['zoneIds' + index], forms['category' + index])">
      {{forms['city' + index]}} 
      <!-- {{forms['category' + index] == 2 ? 'offline' : 'slots'}} -->
    </el-button>
  </div>

  <!-- <el-button :style="{fontWeight: '700'}" text @click="dialogVisible = true">
    Setting custom buttons
  </el-button> -->

  <el-dialog
    v-model="dialogVisible"
    title="Setting custom buttons"
    width="30%"
    :before-close="handleClose"
    class="wrapDialog"
    :style="{minHeight: '100vh', 'margin': '0', width: '100vw'}"
  >
    <div v-for="index in 6">
      <el-form-item label="Name">
        <el-input v-model="forms['city' + index]" />
      </el-form-item>
      <el-form-item label="Zones">
        <el-input v-model="forms['zoneIds' + index]" />
      </el-form-item>
      <el-form-item label="Category">
        <el-radio-group v-model="forms['category' + index]">
          <el-radio label="2">Offline</el-radio>
          <el-radio label="1">Slots -</el-radio>
          <el-radio label="5">Slots +</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-divider />
    </div>
    
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="sendResult">
          Confirm
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
    import ApiSetting from "@/api/setting";
    import { mapGetters } from "vuex";
    import _ from "lodash";

    export default {
        data() {
            return {
              dialogVisible: false,
              buttonsLoaded: false,
              forms: new Array({
                "city1": null,
                "category1": 1,
                "zoneIds1": "",
                "city2": null,
                "category2": "1",
                "zoneIds2": "",
                "city3": null,
                "category3": "1",
                "zoneIds3": "",
                "city4": null,
                "category4": "1",
                "zoneIds4": "",
                "city5": null,
                "category5": "1",
                "zoneIds5": "",
                "city6": null,
                "category6": "1",
                "zoneIds6": ""
              }),
            };
        },
        computed: {
          ...mapGetters("User", ["user"]),
          rolesLoaded() {
            return Array.isArray(this.user.roles);
          },
          isFirefighter() {
            return _.some(this.user.roles, (role) => role.roleName === "Firefighter");
          },
          isManager() {
            return _.some(this.user.roles, (role) => role.roleName === "Manager");
          },
          showDayMenu() {
            return this.rolesLoaded && (!this.isFirefighter || this.isManager);
          },
          firstVisibleButton() {
            for (let index = 1; index <= 6; index++) {
              const city = this.forms["city" + index];
              const category = this.forms["category" + index];
              if (
                typeof city != "undefined" &&
                typeof category != "undefined" &&
                city != null &&
                city.length > 0
              ) {
                return { zoneIds: this.forms["zoneIds" + index], category };
              }
            }
            return null;
          },
        },
        watch: {
          rolesLoaded() {
            this.applyDefaultButton();
          },
          buttonsLoaded() {
            this.applyDefaultButton();
          },
          $route() {
            this.applyDefaultButton();
          },
        },
        methods: {
          hasActiveFilter() {
            const url = new URL(window.location);
            return [
              "filter[mustDone]",
              "filter[zoneIds]",
              "filter[category]",
              "filter[location]",
              "filter[minFilling]",
              "filter[maxFilling]",
            ].some((key) => url.searchParams.has(key));
          },
          applyDefaultButton() {
            if (!this.rolesLoaded || !this.buttonsLoaded) return;
            if (this.showDayMenu) return;
            if (this.hasActiveFilter()) return;

            const btn = this.firstVisibleButton;
            if (btn) {
              this.getTaskByLocation(btn.zoneIds, btn.category);
            }
          },
          sendResult() {
            this.dialogVisible = false

            ApiSetting.sendResult(this.forms)
          },
          getTaskByLocation(elem, category) {
            this.toggleMenu = false;
            const url = new URL(window.location);

            if (elem) {
              // this.chosenCategory = elem.text;
              url.searchParams.delete("filter[mustDone]");
              url.searchParams.delete("filter[minFilling]", 24);
              url.searchParams.delete("filter[maxFilling]", 76);

              url.searchParams.set("filter[zoneIds]", elem);
              url.searchParams.set("filter[category]", category);
              if (category == 1) {
                url.searchParams.set("filter[minFilling]", 24);
              }
              if (category == 5) {
                url.searchParams.set("filter[maxFilling]", 76);
              }
              window.history.pushState({}, "", url);

              this.$router.replace(`${this.$route.path}?${url.search}`);
            } else {
              url.searchParams.delete("filter[mustDone]");
              url.searchParams.delete("filter[zoneIds]");
              url.searchParams.delete("filter[category]");
              url.searchParams.delete("filter[minFilling]", 24);
              url.searchParams.delete("filter[maxFilling]", 76);
              window.history.pushState({}, "", url);

              this.$router.replace(`${this.$route.path}?${url.search}`);
            }
          },
        },
        mounted() {
          ApiSetting.getButtons().then( responce => {
              this.forms = responce.data[0]
              this.buttonsLoaded = true
          })
        }
    }

</script>

<style lang="scss" scoped>
    .dialog-footer button:first-child {
        margin-right: 10px;
    }

    .el-dialog {
      width: 100vw;
      /* min-width: 100vw; */
      height: 100vh;
      margin: 0;
    }
</style>